import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import './index.less'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { EnumAgreement } from "@/utils/enum";
import logo from '@/assets/logo.png'

const { Footer } = Layout;


export default function FooterBar() {
    const navigate = useNavigate();
    const [isWhite, setIsWhite] = useState(false);
    const location = useLocation();
    console.log(location.pathname)

    useEffect(() => {
        if ('/info' === location.pathname) {
            setIsWhite(true);
        } else {
            setIsWhite(false);
        }
    })

    return (
        <div className="footer-heart">
            <div className="footer-content">
                <div className="column">
                    <img src={logo} className='logo' alt="" />
                    <div className="every" onClick={() => { window.open("/userAgreement?typ=" + EnumAgreement.fuwu, '_blank') }}>服务协议</div>
                    <div className="every" onClick={() => { window.open("/userAgreement?typ=" + EnumAgreement.yinsi, '_blank') }}>隐私协议</div>
                    <div className="every" onClick={() => { window.open("/userAgreement?typ=" + EnumAgreement.guanyu, '_blank') }}>关于我们</div>
                </div>
                <div className="bottom">
                    <a className="url" href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#999999' }}
                        >
                        浙ICP备2024062727号-1
                    </a>｜
                    <div className="beian">
                        <img style={{ marginRight: 5 }} src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="公安" width="14" height="14" />
                        <a className="url" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33020302001924"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#999999' }}
                            >
                            浙公网安备33020302001924号
                        </a >
                    </div>

                </div>
            </div>
        </div>)
}